import { i as u, x as p } from "./lit-element-6iugfgmM.js";
import { S as l } from "./sizedMixin-B6C_XO64.js";
import { S as c } from "./Base-pdJ5fkYW.js";
import { n as g } from "./property-BWlAHqg_.js";
import { i as m } from "./query-D8_rwLua.js";
import { d } from "./define-element-Dl91r6Vu.js";
const b = u`
    :host{--spectrum-buttongroup-spacing:var(--mod-buttongroup-spacing,var(--mod-buttongroup-spacing-horizontal,var(--spectrum-spacing-300)));--spectrum-buttongroup-display:flex;--spectrum-buttongroup-flex-direction:row;--spectrum-buttongroup-justify-content:var(--mod-buttongroup-justify-content,normal)}:host([size=s]){--spectrum-buttongroup-spacing:var(--mod-buttongroup-spacing,var(--mod-buttongroup-spacing-horizontal,var(--spectrum-spacing-200)))}:host([vertical]){--mod-buttongroup-spacing:var(--mod-buttongroup-spacing-vertical);--spectrum-buttongroup-display:inline-flex;--spectrum-buttongroup-flex-direction:column}:host{display:var(--spectrum-buttongroup-display);flex-direction:var(--spectrum-buttongroup-flex-direction);gap:var(--spectrum-buttongroup-spacing);justify-content:var(--spectrum-buttongroup-justify-content);flex-wrap:wrap}::slotted(*){flex-shrink:0}:host([vertical]) ::slotted(sp-action-button){--spectrum-actionbutton-label-flex-grow:1}:host([dir=ltr][vertical]) ::slotted(sp-action-button){--spectrum-actionbutton-label-text-align:left}:host([dir=rtl][vertical]) ::slotted(sp-action-button){--spectrum-actionbutton-label-text-align:right}
`;
var h = Object.defineProperty, i = (e, t, r, f) => {
  for (var a, o = void 0, s = e.length - 1; s >= 0; s--) (a = e[s]) && (o = a(t, r, o) || o);
  return o && h(t, r, o), o;
};
class n extends l(c, { noDefaultSize: !0 }) {
  constructor() {
    super(...arguments), this.vertical = !1;
  }
  static get styles() {
    return [b];
  }
  updated(t) {
    super.updated(t), t.has("size") && this.manageChildrenSize(this.slotElement);
  }
  handleSlotchange({ target: t }) {
    this.manageChildrenSize(t);
  }
  manageChildrenSize(t) {
    t.assignedElements().forEach((r) => {
      r.size = this.size;
    });
  }
  render() {
    return p`
            <slot @slotchange=${this.handleSlotchange}></slot>
        `;
  }
}
i([g({ type: Boolean, reflect: !0 })], n.prototype, "vertical"), i([m("slot")], n.prototype, "slotElement"), d("sp-button-group", n);
//# sourceMappingURL=sp-button-group-B-hQqj2b.js.map
